<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
          <strong>Avisos</strong>
        </h2>
      </mdb-col>
      <mdb-col>
        <div class="mt-lg-4 mb-1 pb-1">
          <mdb-form-inline>
            <input
              v-on:keydown.enter.prevent="''"
              class="mr-sm-2 filter-input"
              type="text"
              v-model="search"
              style="width: 100% !important; border: 0px !important;"
              placeholder="Buscar avisos"
            />
          </mdb-form-inline>
        </div>
      </mdb-col>
    </mdb-row>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div
            class="view view-cascade narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
            style="margin-top: -2.25rem; background-color: #67a3cf; position: static;"
          >
            <div class="text-left">
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Nuevo aviso</span>
                <a slot="reference" href="/newNotice">
                  <img
                    alt="crear nuevo aviso"
                    class="mt-0"
                    :src="imgServer+'apps/myfrac/admin/assets/Crear_BTN@3x.png'"
                    style="margin-left: 1rem; width: 31.2px; height: 31.2px; object-fit: contain;"
                  />
                </a>
              </mdb-tooltip>
            </div>

            <span
              class="white-text"
              style="font-family: OpenSans-Bold; font-size: 16px; display: table; margin: 0 auto;"
            >Avisos registrados</span>

            <div class="text-right" style=" margin-top: -10px; display: flex; float: right;"></div>
          </div>
          <mdb-container>
            <div class="offset">
              <mdb-tbl class="table-st">
                <mdb-tbl-head class="text-center" responsive>
                  <tr>
                    <th scope="col">Título</th>
                    <th scope="col">Fecha de inicio</th>
                    <th scope="col">Fecha de término</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                  <tr v-for="(item, index) in displayedPost" v-bind:key="index">
                    <td>{{item.title}}</td>
                    <td>{{transformDate(item.startDate)}}</td>
                    <td>{{transformDate(item.endDate)}}</td>
                    <td>
                      <div>
                        <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Editar</span>
                          <mdb-btn
                            slot="reference"
                            outline="white"
                            rounded
                            size="sm"
                            class="px-2 button_background"
                            @click="getSingleNotice(item.uuid)"
                          >
                            <mdb-icon icon="edit" class="mt-0" />
                          </mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip v-if="isMe.idUsersTypes != 2" material trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Eliminar</span>

                          <mdb-btn
                            slot="reference"
                            outline="white"
                            rounded
                            size="sm"
                            class="px-2 ml-2 button_background"
                            style="width: 2rem;"
                            @click="deleteNotice(item.uuid, item.title)"
                          >
                            <mdb-icon icon="trash" />
                          </mdb-btn>
                        </mdb-tooltip>
                      </div>
                    </td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>

              <nav aria-label="Page navigation example">
                <ul class="pagination pg-blue justify-content-center">
                  <li class="page-item">
                    <a
                      v-if="page != 1"
                      class="page-link Trazado-295"
                      @click="page--"
                      tabindex="-1"
                    >&laquo;</a>
                  </li>
                  <li class="page-item" v-for="pageNumber in pages.slice(page-1, page+5)" :key="pageNumber">
                    <a class="page-link Trazado-295" @click="page = pageNumber">{{pageNumber}}</a>
                  </li>
                  <li class="page-item">
                    <a
                      v-if="page < pages.length"
                      @click="page++"
                      class="page-link Trazado-295"
                    >&raquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </mdb-container>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { ModelSelect } from "vue-search-select";
import { mapGetters, mapActions } from "vuex";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbIcon,
  mdbFormInline,
  mdbInput,
  mdbDatatable,
  mdbAvatar,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTbl,
  mdbTblHead,
  mdbTblBody,
  mdbTextarea
} from "mdbvue";

export default {
  name: "Gates",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbIcon,
    mdbFormInline,
    mdbInput,
    mdbDatatable,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    ModelSelect,
    mdbTextarea
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      noticesList: [],
      page: 1,
      perPage: 15,
      pages: [],
      numberOfPages: 0,
      requestShow: false,
      showModal: false,
      search: null,
      TitleModal: "Nuevo",
      gate: [],
     
    };
  },
  methods: {
  transformDate(date){
    var auxDate = date.split("T")[0]
    var auxTime = date.split("T")[1]

    return auxDate+" "+auxTime;

  },
  getNotices() {
      let aux = this;
      Axios.get(Servers.serverApi + "api/notices", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
         ;
          //aux.noticesList = response.data;
          const data = response.data;
          // Ordena por startDate descendente, si hay al menos 1 objeto
          const sortedData = data.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
          aux.noticesList = sortedData;
          aux.numberOfPages = Math.ceil(aux.noticesList.length / aux.perPage);
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    async getSingleNotice(uuid) {
      // this.TitleModal = "Editar";
      // this.showModal = true;
      // let found = this.noticesList.find(element => element.uuid == uuid);
      // this.gate = found;
      // this.$store.commit('cm/setComunity', found);
      // this.$store.commit('cm/setEdit', true);
      // //console.log(this.$store.state.cm.comunityObject)
      // window.location.href = '/newNotice'

      await this.$store.dispatch("cm/getInfoNotice", uuid)
      this.$router.push("newNotice")

      
    },
   
    deleteNotice(uuid, name) {
      let aux = this;
      Swal.fire({
        title: "¿Seguro que deseas eliminar " + name + "?",
        text: "No podrás revetir esta acción",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          Axios.delete(Servers.serverApi + "api/notices/" + uuid, {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token")
            }
          })
            .then(function(response) {
              aux.showMessageSucces();
            })
            .catch(function(error) {
              console.log(error.response.data);
            });
        }
      });
    },
    setPages() {
      this.pages=[];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / aux.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function() {
      Swal.fire({
        title: "<span style='font-size: 20px;'>¡Correcto!</span>",
        html: "<span style='font-size: 12px;'></span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          window.location.reload();
        }
      });
    },
   
  },
  mounted() {},
  created() {
    //this.checkMe();
    
    this.getNotices();
  },
  watch: {
  noticesList() {
      this.setPages();
    },
  
    
  },
  computed: {
     ...mapGetters({
      isMe:"getWhoAmi",
    }),
    displayedPost() {
      if (this.search) {
        this.page=1
        return this.paginate(
          this.noticesList.filter(item => {
            return (
              item.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            );
          })
        );
      } else return this.paginate(this.noticesList);
    },
    characterRemaining: function() {
      return this.noticeDesc.length;
    }
  },
  watch: {
    '$route'(to, from) {
      if (this.$store.state.cm.reloadNotices) {
        this.getNotices(); // recarga la lista
        this.$store.commit('cm/setReloadNotices', false);
      }
    }
  }

};
</script>

<style scoped>

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #fff;
}

.table-st {
  border-collapse: collapse !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.HeadBG {
  background-color: #f5f6fa;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center !important;
}

.table > tbody {
  text-align: center;
}

.Trazado-295 {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec !important;
  background-color: #ffffff !important;
}

.filter-input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-top: 2rem;
  border-radius: 25px;
  height: 35px;
  padding-left: 35px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf;
  background-size: 20px 20px;
}

.filter-input:focus {
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf;
  background-size: 20px 20px;
}

.modal-header-style {
  height: 51.5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #67a3cf;
}

.table > thead > tr > th{
  text-align: center !important;
}
</style>

<style>

</style>